import type { Offer } from '@/types';

export const mockOffers: Offer[] = [
  {
    id: 'offer-001',
    partner_id: 'partner-001',
    vertical_id: 'legal',
    geo_id: 'NL-NH-AMS',
    payout_model: 'cpl',
    payout_config: { rate_local: 125, rate_eur: 125, currency: 'EUR' },
    caps: { daily: 3, weekly: 15, monthly: 30 },
    schedule: { always_on: true },
    filter_rules: {
      case_types: ['personal_injury', 'auto_accident'],
      jurisdiction_states: ['NL'],
      injury_severity: ['moderate', 'severe', 'catastrophic']
    },
    priority: 80,
    status: 'active',
    requires_tcpa_consent: false,
    effective_from: '2024-01-15',
    effective_until: null,
    created_at: '2024-01-15T00:00:00Z',
    updated_at: '2025-04-01T00:00:00Z',
    archived_at: null
  },
  {
    id: 'offer-002',
    partner_id: 'partner-002',
    vertical_id: 'real_estate',
    geo_id: 'US-NY-NYC',
    payout_model: 'cpl',
    payout_config: { rate_local: 95, rate_eur: 88, currency: 'USD' },
    caps: { daily: 5, weekly: 25, monthly: 60 },
    schedule: { always_on: true },
    filter_rules: {
      lead_types: ['buyer'],
      price_range_min_eur: 400000,
      price_range_max_eur: 800000,
      timelines: ['immediately', '1_3_months']
    },
    priority: 90,
    status: 'active',
    requires_tcpa_consent: false,
    effective_from: '2024-02-01',
    effective_until: null,
    created_at: '2024-02-01T00:00:00Z',
    updated_at: '2025-03-15T00:00:00Z',
    archived_at: null
  },
  {
    id: 'offer-003',
    partner_id: 'partner-003',
    vertical_id: 'home_services',
    geo_id: 'NL-NH-AMS',
    payout_model: 'cpl',
    payout_config: { rate_local: 75, rate_eur: 75, currency: 'EUR' },
    caps: { daily: 4, weekly: 20, monthly: 40 },
    schedule: { always_on: true },
    filter_rules: {
      service_types: ['flooring'],
      floor_types: ['pvc', 'laminate', 'gietvloer', 'parket'],
      project_sizes: ['small_lt_2k', 'medium_2k_10k', 'large_10k_50k'],
      timeline_urgency: ['within_1_month', '1_3_months']
    },
    priority: 75,
    status: 'active',
    requires_tcpa_consent: false,
    effective_from: '2024-03-01',
    effective_until: null,
    created_at: '2024-03-01T00:00:00Z',
    updated_at: '2025-04-10T00:00:00Z',
    archived_at: null
  },
  {
    id: 'offer-004',
    partner_id: 'partner-004',
    vertical_id: 'healthcare',
    geo_id: 'NL-NH-AMS',
    payout_model: 'flat_subscription',
    payout_config: { monthly_fee_eur: 500, included_leads: 30, overage_eur: 20 },
    caps: { daily: null, weekly: null, monthly: 30 },
    schedule: { always_on: true },
    filter_rules: {
      specialties: ['physiotherapy', 'orthopedics'],
      insurance_status: ['insured', 'uninsured'],
      urgency: ['within_1_week', 'within_1_month']
    },
    priority: 70,
    status: 'active',
    requires_tcpa_consent: false,
    effective_from: '2024-03-15',
    effective_until: null,
    created_at: '2024-03-15T00:00:00Z',
    updated_at: '2025-02-20T00:00:00Z',
    archived_at: null
  },
  {
    id: 'offer-005',
    partner_id: 'partner-005',
    vertical_id: 'loans',
    geo_id: 'US-CA',
    payout_model: 'cpa',
    payout_config: { pct_of_value: 12, min_eur: 50, max_eur: 2000 },
    caps: { daily: 8, weekly: 40, monthly: 100 },
    schedule: { always_on: true },
    filter_rules: {
      loan_types: ['mortgage', 'home_equity'],
      credit_score_ranges: ['excellent_750+', 'good_700_749', 'fair_650_699'],
      employment_statuses: ['employed_fulltime', 'self_employed']
    },
    priority: 75,
    status: 'active',
    requires_tcpa_consent: true,
    effective_from: '2024-04-01',
    effective_until: null,
    created_at: '2024-04-01T00:00:00Z',
    updated_at: '2025-04-01T00:00:00Z',
    archived_at: null
  },
  {
    id: 'offer-006',
    partner_id: 'partner-006',
    vertical_id: 'legal',
    geo_id: 'US-TX',
    payout_model: 'revshare',
    payout_config: { pct_of_contract_value: 15 },
    caps: { daily: 2, weekly: 10, monthly: 25 },
    schedule: { always_on: true },
    filter_rules: {
      case_types: ['personal_injury', 'workers_comp', 'auto_accident'],
      jurisdiction_states: ['US-TX'],
      injury_severity: ['severe', 'catastrophic']
    },
    priority: 85,
    status: 'active',
    requires_tcpa_consent: true,
    effective_from: '2024-04-15',
    effective_until: null,
    created_at: '2024-04-15T00:00:00Z',
    updated_at: '2025-03-20T00:00:00Z',
    archived_at: null
  },
  {
    id: 'offer-007',
    partner_id: 'partner-002',
    vertical_id: 'real_estate',
    geo_id: 'US-NY',
    payout_model: 'cpl',
    payout_config: { rate_local: 75, rate_eur: 69, currency: 'USD' },
    caps: { daily: 3, weekly: 15, monthly: 35 },
    schedule: { always_on: true },
    filter_rules: {
      lead_types: ['seller'],
      price_range_min_eur: 300000,
      timelines: ['immediately', '1_3_months']
    },
    priority: 55,
    status: 'active',
    requires_tcpa_consent: false,
    effective_from: '2024-05-01',
    effective_until: null,
    created_at: '2024-05-01T00:00:00Z',
    updated_at: '2025-04-15T00:00:00Z',
    archived_at: null
  }
];